exports.components = {
  "component---src-pages-competencies-mdx": () => import("./../../../src/pages/competencies.mdx" /* webpackChunkName: "component---src-pages-competencies-mdx" */),
  "component---src-pages-index-mdx": () => import("./../../../src/pages/index.mdx" /* webpackChunkName: "component---src-pages-index-mdx" */),
  "component---src-pages-work-mdx": () => import("./../../../src/pages/work.mdx" /* webpackChunkName: "component---src-pages-work-mdx" */)
}

